const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1'])


export function apiBaseUrl(location) {
  const context = location.pathname?.match(/^\/c\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\//)?.[0]?.replace(/\/$/, '') || ''
  if (LOOPBACK_HOSTS.has(location.hostname)) {
    return `http://${location.hostname}:8001${context}/api`
  }
  return `${location.origin}${context}/api`
}


export function avatarDisplayUrl(avatarUrl, location) {
  if (!avatarUrl) return ''
  if (!LOOPBACK_HOSTS.has(location.hostname.toLowerCase())) return avatarUrl

  try {
    const parsedUrl = new URL(avatarUrl, location.origin)
    if (LOOPBACK_HOSTS.has(parsedUrl.hostname.toLowerCase())) {
      return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`
    }
  } catch {
    return avatarUrl
  }

  return avatarUrl
}


export const ADMIN_PORTAL_URL = 'https://admin.autosquare.org.cn/'
